export const EXTERNAL_ROUTES = {
    ROOT: '/',

    NID: {
        LOGIN: '/nidlogin.login',
        LOGOUT: '/nidlogin.logout',
    },

    MYDATA: {
        HOME: '/mydata/home',

        MANAGEMENT: {
            INDEX: '/mydata/management',
            DISMISS: '/mydata/management/dismiss',
            HISTORY: '/mydata/management/history/[orgCode]',
            PERSONAL_INFO_HISTORY: '/mydata/management/history/personal-info/[view]',
            CORP: '/mydata/management/corp/[orgCode]',
            ASSET: '/mydata/management/asset/[status]/[id]',
            ACCOUNTS: '/mydata/management/accounts',
            PAYMONEY: '/mydata/management/asset/paymoney/[corpId]',
        },

        INSURANCE: {
            MY: {
                HOME: '/mydata/myasset/insurance/my',
                EXPIRED: '/mydata/myasset/insurance/my/expired',
                DETAIL: {
                    HOME: '/mydata/myasset/insurance/my/[id]',
                    GENERAL: '/mydata/myasset/insurance/my/[id]/general',
                    CAR: '/mydata/myasset/insurance/my/[id]/car/[carId]',
                    GUARANTEE: '/mydata/myasset/insurance/my/[id]/guarantee',
                    FREE: '/mydata/myasset/insurance/my/[id]/free/[insuranceId]',
                    STATEMENTS: '/mydata/myasset/insurance/my/[id]/statements/',
                },
                COVERAGE: {
                    HOME: '/mydata/myasset/insurance/my/coverages',
                    DETAIL: '/mydata/myasset/insurance/my/coverages/[type]',
                },
                AGREEMENT: '/mydata/myasset/insurance/my/agreement',
            },
            CONTENTS: {
                HOME: `/mydata/myasset/insurance/contents`,
                DETAIL: `/mydata/myasset/insurance/contents/[id]`,
                CATEGORY: `/mydata/myasset/insurance/contents/category/[category]`,
                SEARCH: `/mydata/myasset/insurance/contents/search`,
            },
        },

        INVEST: {
            ACCOUNT: '/myasset/invest/account',
            INVESTMENT_DETAIL: '/mydata/myasset/invest/detail/account/[assetId]',
        },
    },

    SAVINGS: {
        MAIN: '/savings',
        DEPOSIT_LIST: '/savings/list/deposit',
        SAVING_LIST: '/savings/list/saving',
        PARKING_LIST: '/savings/list/parking',
    },

    MYMONEY: {
        // 신버전
        MAIN: '/mymoney',

        // 카드
        CREDITCARD: '/mymoney/creditcard',
        CREDITCARD_USAGE: '/mymoney/creditcard/usage',
        CREDITCARD_USAGE_DETAIL: '/mymoney/creditcard/usage/detail',
        CREDITCARD_USAGE_DETAIL_CONTENT: '/mymoney/creditcard/usage/detail/content',
        CREDITCARD_USAGE_BENEFIT_STATUS: '/mymoney/creditcard/usage/benefit/status',
        CREDITCARD_USAGE_SETTING: '/mymoney/creditcard/usage/setting',
        CREDITCARD_MODIFY: '/mymoney/creditcard/modify',

        // CREDITCARD_USAGE_BENEFIT_INFO: '/mymoney/creditcard/usage/benefit/info',
        CREDITCARD_BILL: '/mymoney/creditcard/bill',
        CREDITCARD_BILL_BILLID: '/mymoney/creditcard/bill/:billId',
        CREDITCARD_BILL_BILLID_BILLDETAILID: '/mymoney/creditcard/bill/:billId/:billDetailId',
        CREDITCARD_POINT: '/mymoney/creditcard/point',

        ACCOUNT: '/mymoney/account',

        ACCOUNT_BANK: '/mymoney/account/bank',
        ACCOUNT_STOCK: '/mymoney/account/stock',
        ACCOUNT_STOCK_INVESTMENT: '/mymoney/account/stock/investment',
        ACCOUNT_STOCK_INVESTMENT_DETAIL: '/mymoney/account/stock/investment/:id/:holdingId',

        ACCOUNT_DETAIL: '/mymoney/account/:id',
        ACCOUNT_SETTING: '/mymoney/account/setting/:id',

        ACCESS: '/mymoney/access',
        AGREEMENT: '/mymoney/agreement',

        // 등록
        REGISTRATION: '/mymoney/registration',
        REGISTRATION_PROCESS: '/mymoney/registration/process',
        REGISTRATION_COMPLETION: '/mymoney/registration/completion',

        REGISTRATION_REMIT_AGREEMENT: '/mymoney/registration/remit/agreement', // 간편결제계좌 연결동의
        REGISTRATION_REMIT_ACCOUNT: '/mymoney/registration/remit/account', // 계좌번호 입력
        REGISTRATION_REMIT_AUTH_ARS: '/mymoney/registration/remit/auth/ars', // ARS 인증
        REGISTRATION_REMIT_AUTH_ARS_COMPLETION: '/mymoney/registration/remit/auth/ars/completion', // ARS 인증 완료
        REGISTRATION_REMIT_AUTH_ACCOUNT: '/mymoney/registration/remit/auth/account', // 1원 인증

        CERTIFICATE_EXCHANGE: '/mymoney/certificate/exchange',
        // REMIT: {
        //     MAIN: '/remit',
        //     REGISTRATION: '/remit/registration',
        //     REGISTRATION_PROCESS: '/remit/registration/process',
        //     AGREEMENT_PRIVACY: '/remit/agreement/privacy',

        //     AGREEMENT_CONNECT: '/remit/agreement/connect',
        // },
    },
    CPM: {
        MAIN: '/cpm',
        MEMBERSHIP: '/cpm/membership',
        ERROR: '/cpm/error/page',
        SHORTCUT: '/cpm/create/shortcut',
        SERVICE_CONSENT: '/cpm/consent/service',
        PERSONAL_INFO_CONSENT: '/cpm/consent/personal/info',
        LOCATION_INFO_CONSENT: '/cpm/consent/location/info',
        FOREIGN_COUNTRY_PAYMENT_INFO_CONSENT: '/cpm/consent/foreign/country/payment/info',
        FOREIGN_COUNTRY_PAYMENT_TRANSACTION_INFO_AGREEMENT_CONSENT:
            '/cpm/consent/foreign/country/payment/transaction/agreement/info',
        PAYMENT_COMPLETE: '/cpm/payment/complete',
        FULL_SCREEN_LOADING: '/cpm/loading/page',
        ACCOUNT_ENROLL: '/cpm/account/enroll',
        FOREIGN_COUNTRY_PAYMENT_CONSENT: '/cpm/consent/foreign/country/payment',
        FOREIGN_COUNTRY_PAYMENT_COMPLETE: '/cpm/foreign/country/payment/complete',
        FRANCHISE: '/cpm/franchise/list',
        FRANCHISE_HELP: '/cpm/franchise/help',
    },

    MY_CAR: '/mycar',
    MY_CAR_HOME: '/mycar/home',
    MY_CAR_APPLY: '/mycar/apply',
    MY_CAR_APPLY_TERMS_OF_SERVICE: '/mycar/apply/tos',
    MY_CAR_APPLY_TERMS_OF_SERVICE_DESC: '/mycar/apply/tos/desc',
    MY_CAR_APPLY_TERMS_OF_SERVICE_NAVER_MAP: '/mycar/apply/tos/map',
    MY_CAR_APPLY_RESTRICTION: '/mycar/apply/restriction',
    MY_CAR_SETTING: '/mycar/setting',
    MY_CAR_SETTING_GARAGE: '/mycar/setting/garage',
    MY_CAR_SETTING_TIRE: '/mycar/setting/tire',
    MY_CAR_SETTING_WARRANTY: '/mycar/setting/warranty',
    MY_CAR_SETTING_MILEAGE: '/mycar/setting/mileage',
    MY_CAR_SETTING_INSURANCE: '/mycar/setting/insurance',
    MY_CAR_SALE: '/mycar/sale',
    MY_CAR_SALE_HOME: '/mycar/sale/home',
    MY_CAR_SALE_DETAIL: '/mycar/sale/:carNum/detail',
    MY_CAR_SALE_RESULT: '/mycar/sale/:carNum/result',

    PAY_SERVICE: '/payservice',
    MY_WALLET: '/',
    MY_ASSET: '/mymoney', // (구)내 자산 페이지와 호환을 위해서, /mymoney 를 사용함.
    HISTORY_BENEFIT: '/historybenefit',
    PAYMENT_HISTORY: '/historybenefit/paymenthistory',
    EVENT_BENEFIT: '/historybenefit/eventbenefit',
    EVENT_BENEFIT_BRIDGE: '/eventbenefit/bridge',

    PAYLATER: '/paylater',
    PAYLATER_BRIDGE: '/paylater/bridge',
    PAYLATER_BILL: '/paylater/bill/:statement',
    PAYLATER_ENROLL: '/paylater/enroll',
    PAYLATER_ENROLL_AGREEMENT: '/paylater/enroll/agreement',
    PAYLATER_ENROLL_AGREEMENT_CONTENT: '/paylater/enroll/agreement/:term',
    PAYLATER_ENROLL_FORM: '/paylater/enroll/form',
    PAYLATER_ENROLL_PROCESSING: '/paylater/enroll/processing',
    PAYLATER_ENROLL_COMPLETE: '/paylater/enroll/complete',
    PAYLATER_SIGNUP: '/paylater/signup',
    PAYLATER_ERROR: '/paylater/error',
    PAYLATER_ENROLL_FAIL: '/paylater/error/enroll',
    PAYLATER_PAYMENT_FAIL: '/paylater/error/payment',
    PAYLATER_PAYMENT: '/paylater/payment',
    PAYLATER_PAYMENT_SETTING: '/paylater/payment/setting',
    PAYLATER_PAYMENT_COMPLETE: '/paylater/payment/complete',
    PAYLATER_TRADE: '/paylater/trade',
    PAYLATER_OVERDUE: '/paylater/overdue',
    PAYLATER_LIMIT_INFO: '/paylater/limit',
    PAYLATER_GUIDE: '/paylater/guide',

    NAVER_MEMBERSHIP: '/navermembership',
    NAVER_MEMBERSHIP_SHOPPING_BENEFIT: '/navermembership/shoppingbenefit',

    MEMBERSHIP: '/membership',
    MEMBERSHIP_ENROLL: '/membership/enroll',
    MEMBERSHIP_ENROLL_CHECKINFO: '/membership/enroll/checkinfo',
    MEMBERSHIP_ENROLL_CHECKTERMS: '/membership/enroll/checkterms',
    MEMBERSHIP_MANAGEMENT: '/membership/management',
    MEMBERSHIP_DIRECT_ADD: '/membership/directadd',
    MEMBERSHIP_DETAIL: '/membership/detail',
    MEMBERSHIP_DETAIL_BENEFIT: '/membership/detail/benefit',
    MEMBERSHIP_DETAIL_LIST: '/membership/detail/list',

    ERROR: '/error',
    STOP: '/stop',

    BANK_BOOK: {
        MAIN: '/bankbook',
        ERROR: '/bankbook/error', // 에러
        APPLY: '/bankbook/apply', // 상품 상세
        DESC: '/bankbook/desc',
        DESC_GUIDE: '/bankbook/desc/guide', // 상품 정보
        MY: '/bankbook/my',
        MY_HOME: '/bankbook/my/home', // 통장 홈
        MY_GRADE: '/bankbook/my/grade', // 내 등급
        MY_STATUS: '/bankbook/my/status', // 통장 상태
        MY_PURCHASE: '/bankbook/my/purchase', // 구매 내역
        MY_EARNING: '/bankbook/my/earning', // 수익내역
        MY_BENEFIT: '/bankbook/my/benefit', // 혜택 내역
    },
    AUTO_PAY: {
        MAIN: '/autopay',
        SKT: '/autopay/skt', // skt 통신요금 자동 납부
        COMPLETED: '/autopay/completed', // 자동납부 완료 페이지
        AGREEMENT: '/autopay/agreement', // 제 3 자 동의 페이지
        PERSONAL_INFO_AGREEMENT: '/autopay/agreement/personalinfo', // 개인정보 제공 동의 페이지
    },
    NOT_FOUND: '/notFound',

    KEYPAD: '/keypad',
    BLOCK: '/block',
    NAVER_CERT_BRIDGE: '/naverCertBridge',

    AD_REWARD_CONTACT: '/historybenefit/adreward',

    CREDIT_SCORING: {
        INTRODUCE: '/creditscoring/introduce',
        PROVISION_NICE: '/creditscoring/introduce/provision/nice',
        PROVISION_INFO: '/creditscoring/introduce/provision/info',
        PROVISION_OFFER: '/creditscoring/introduce/provision/offer',
        PROVISION_OFFER_NF: '/creditscoring/introduce/provision/offer_nf',
        PROVISION_OFFER_OPTIONAL: '/creditscoring/introduce/provision/offer_optional',
        PROVISION_CUSTOM: '/creditscoring/introduce/provision/custom',
        PROVISION_MARKETING: '/creditscoring/introduce/provision/marketing',
        PROVISION_MAIN: '/creditscoring/provision',
        PROVISION_PERSONAL: '/creditscoring/provision/personal',
        PROVISION_THIRD_INFO: '/creditscoring/provision/thirdinfo',
        PROVISION_EXTRA_OFFER_OPTIONAL: '/creditscoring/provision/offer_optional',
        NOTI: '/creditscoring/noti',
        MAIN: '/creditscoring',
        FAQ: '/creditscoring/faq',
        REPORT: '/creditscoring/report',
        STATUS: '/creditscoring/status',
        STATUS_CARD: '/creditscoring/status#card',
        STATUS_LOAN: '/creditscoring/status#loan',
        INCREMENT: '/creditscoring/increment',
        INCREMENT_SUBMIT_HISTORY: '/creditscoring/increment/submithistory',
        INCREMENT_SUBMIT_LOADING: '/creditscoring/increment/submit/loading/:type',
        INCREMENT_SUBMIT_RESULT: '/creditscoring/increment/submit/result/:type',
        CHANGES: '/creditscoring/changes',
        CHANGES_SCORE: '/creditscoring/changes/score',
        CHANGES_CHECK: '/creditscoring/changes/check',
        CHANGES_CAUSE: '/creditscoring/changes/cause',
        HISTORY_MAIN: '/creditscoring/history',
        HISTORY_CARD: '/creditscoring/history/card',
        HISTORY_CARD_DETAIL: '/creditscoring/history/card/detail/:index',
        HISTORY_LOAN: '/creditscoring/history/loan',
        HISTORY_LOAN_DETAIL: '/creditscoring/history/loan/detail/:index',
        HISTORY_OVERDUE: '/creditscoring/history/overdue',
        HISTORY_GUARANTEE: '/creditscoring/history/guarantee',
    },

    SME_LOAN: {
        MAIN: '/smartstore_loan',
        INFO: {
            MAIN: '/smartstore_loan/info',
            EVALUATE: {
                MAIN: '/smartstore_loan/info/1',
                PROVISION: '/smartstore_loan/info/1/provision',
            },
            AGREEMENT: {
                MAIN: '/smartstore_loan/info/2',
                PROVISION: '/smartstore_loan/info/2/provision',
            },
            SELF_AUTH: {
                MAIN: '/smartstore_loan/info/3',
                INQUIRE: '/smartstore_loan/info/3/inquire',
                RETRY: '/smartstore_loan/info/3/retry',
            },
            LOAN_INFO: '/smartstore_loan/info/4',
        },
        LOAN: {
            MAIN: '/smartstore_loan/loan',
            ERROR: '/smartstore_loan/loan/error',
            SCRAPING: '/smartstore_loan/loan/scraping',
        },
        LIST: {
            MAIN: '/smartstore_loan/list',
            DETAIL: '/smartstore_loan/list/detail',
        },
    },

    REMIT: {
        INDEX: '/remit',
        SELECT: {
            INDEX: '/remit/select',
            RECENT: '/remit/select/recent',
            FRIEND: '/remit/select/friend',
            ACCOUNT: '/remit/select/account',
        },
        AMOUNT_INPUT: '/remit/input',
        AMOUNT_CONFIRM: {
            INDEX: '/remit/confirm',
            SHIPPING: '/remit/confirm/shipping',
        },
        DONE: '/remit/done',
        RESERVED: '/remit/reserved',
    },

    VERIFICATION: {
        MAIN: '/verification',
        ID_CHECK: '/verification/id',
        AML_CHECK: '/verification/aml',
    },

    PREPAID_CARD: {
        INTRO: '/prepaid-card/intro',
        HISTORY: '/prepaid-card/history',
        MANAGEMENT: '/prepaid-card/management',
        REGISTER_STATUS: '/prepaid-card/register/status',
    },

    PAY_POINT_CONVERT: {
        INDEX: '/pay-point-convert-in/pointconvert',
    },

    PFMS: {
        REPORT: '/pfms/report',
    },

    POINT_HISTORY: {
        LIST: '/pointshistory/list?category=all',
    },

    PAYMONEY: {
        HISTORY: '/paymoney/history?from=main_pay_icon',
    },

    NOTIFY: {
        FINANCE: '/setting/detail/finance',
    },

    INSURANCE: {MAIN: '/insurance', CAR: '/car', SAVING: '/savings', TRAVEL: '/travel', PET: '/pet', GOLF: '/golf'},
}
